import React from "react";

function Canvas_clearRect() {
  return (
    <div>
      <h1>Canvas_clearRect Component</h1>
      <p>This is the Canvas clearRect tutorial page content.</p>
    </div>
  );
}

export default Canvas_clearRect;
